import styled from 'styled-components';
import * as Styles from '../../utils/styleUtils';

export const SelectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 100%;

  ${Styles.FontStyles}
  background-color: ${({ styleProps }) => styleProps?.backgroundColor};
  padding: 2px;
`;

export const CheckboxPreview = styled.div`
  width: 14px;
  height: 14px;
  border: ${({ isChecked }) => (isChecked ? '1px solid #0078D7;' : '1px solid #333;')};
  border-radius: 2px;
  background-color: ${({ isChecked }) => (isChecked ? '#0078D7' : '#ffffff')};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  /* Show a checkmark if checked */
  &::after {
    content: '${({ isChecked }) => (isChecked ? '✔' : '')}';
    color: #ffffff;
    font-size: 10px;
  }
`;

export const RadioPreview = styled.div`
  width: 14px;
  height: 14px;
  border: ${({ isChecked }) => (isChecked ? '1px solid #0078D7;' : '1px solid #333;')};
  border-radius: 50%;
  background-color: white;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  /* Show an inner dot if checked */
  &::after {
    content: '';
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ isChecked }) => (isChecked ? '#0078D7' : 'transparent')};
  }
`;

export const SelectionLabel = styled.span`
  ${Styles.FontStyles}
`;